<div class="dialog-title" mat-dialog-title>
    <cerrix-title
        style="flex: 1"
        size="large"
        [editable]="false"
        [value]="'Link ' + label + 's'"
    ></cerrix-title>
    <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="dialog-content">
    <mat-tab-group
        class="dialog-content-tab"
        [mat-stretch-tabs]="false"
        preserveContent
        animationDuration="0ms"
        (selectedTabChange)="onTabChange($event)"
    >
        <mat-tab [label]="'All ' + label + 's'" class="tab-content">
            <ng-template mat-tab-label>
                <span [attr.data-uiid]="'incident-links-edit-all-tab'">All {{ label }}s</span>
            </ng-template>
        </mat-tab>
        <mat-tab label="Linked" class="tab-content">
            <ng-template mat-tab-label>
                <span [attr.data-uiid]="'incident-links-edit-linked-tab'">Linked</span>
            </ng-template>
        </mat-tab>
    </mat-tab-group>

    <cerrix-input
        placeholder="Search..."
        [dataUiid]="'incident-links-edit-search-input'"
        (change)="onSearch($event)"
    ></cerrix-input>

    <div class="item-list">
        @for (link of displayedLinks; track link) {
            <div
                class="item"
                data-uiid="incident-links-edit-item"
                [class.selected]="linkMap.has(link.id)"
                (click)="onClick(link.id)"
            >
                <div class="item-title">
                    <span class="item-identifier">
                        @if (padIdentifier) {
                            {{ (link.identifier | number: "8.0-0").replaceAll(",", "") }}
                        } @else {
                            {{ link.identifier }}
                        }
                    </span>
                    |
                    {{ link.name }}
                </div>
            </div>
        }
    </div>
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
    <cerrix-button color="accent" [dataUiid]="'incident-links-edit-cancel-button'" mat-dialog-close
        >Cancel</cerrix-button
    >

    <cerrix-button
        color="success"
        [dataUiid]="'incident-links-edit-link-button'"
        (click)="onApplyChanges()"
        >Link {{ label }}(s)</cerrix-button
    >
</mat-dialog-actions>
